var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.9999H9.692V13.1149H14.308V18.9999H18V9.99991L12 5.46191L6 9.99991V18.9999ZM5 19.9999V9.49991L12 4.21191L19 9.49991V19.9999H13.308V14.1149H10.692V19.9999H5Z",
    fill: "#5F6388"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTask);
export default __webpack_public_path__ + "static/media/newTask.5f6b6e90c025ab9a1d77ce22568a415a.svg";
export { ForwardRef as ReactComponent };